module.exports = __webpack_public_path__ + "assets/c80e89199aef31e48addb2b35ea96365.js";